import $ from "jquery/dist/jquery";

export function locationPathName() {
    return window.location.origin + window.location.pathname
}

export function getUrlWithSerializedForm($form) {
    let permalink = locationPathName();
    let url =  new URL(permalink + '?' + $form.serialize());
    let params = new URLSearchParams(url.search);
    let searchParams = new URLSearchParams(url.search);
    params.delete('action');
    params.delete('is-load-more');
    params.delete('my-page');
    params.delete('posts-not-in');

    searchParams.forEach((value, key) => {
        if( value.length === 0 ) {
            params.delete(key);
        }
    });

    let paramsString = params.toString();

    return ( paramsString ) ? '?' + paramsString : permalink;
}

export function isInViewport($el) {
    if( $el.length ) {
        let elementTop = $el.offset().top;
        let elementBottom = elementTop + $el.outerHeight();

        let viewportTop = $(window).scrollTop();
        let viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    } else {
        return false
    }
}

export function stripHtml(html) {
    let tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
}

export function pageScroll(enabled) {
    if( enabled ) {
        $('html, body').removeClass('gl-no-scroll')
    } else {
        $('html, body').addClass('gl-no-scroll')
    }
}